// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nknj","col":"styles_col__3Wl_B"};